import { SetStateAction, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getSessionStorage } from '../../utils/sessionStorageHandler';
import { permission, sessionStorageKeyAuthorizationToken } from '../../const/commonConst';
import { getSessionInfoHandler } from '../../handler/getSessionInfoHandler';
import { DialogType } from '../../type/DialogType';
import { UserInfoType } from '../../type/UserInfoType';

type InputType = {
	setDialog: (value: SetStateAction<DialogType>) => void;
	setUserInfo: (value: SetStateAction<UserInfoType>) => void;
};

/**
 * セッションデータの状態管理用カスタムフック
 */
export const useEffectGetSessionInfo = (input: InputType) => {
	const { setDialog, setUserInfo } = input;

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		// 認証トークンをセッションストレージから取得する
		const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

		if (location.pathname === '/login') {
			return;
		}

		if (!authorizationToken) {
			navigate('/login');
			return;
		}

		// DynamoDBからセッション情報を取得する
		const getSessionInfo = async (authorizationToken: string) => {
			const [dialog, sessionInfo] = await getSessionInfoHandler(authorizationToken);

			if (!sessionInfo) {
				setDialog(dialog);
				navigate('/login');
				return;
			}

			// URLを直接入力された場合であってもドライバー権限の場合は車両現在位置一覧は表示しない
			if (location.pathname === '/current-car-place' && 
				(sessionInfo.permission === permission.id.driver || sessionInfo.permission === permission.id.unknown)) {
				navigate('/login');
				return;
			}

			setUserInfo(sessionInfo);
		};

		getSessionInfo(authorizationToken);
	}, []);
};
